/**
 * SP: 商品ページのアンカーリンクをヘッダー分オフセットし、
 * LP画像の遅延読み込み後に再スクロールする。
 */
(function () {
  const MOBILE_MQ = window.matchMedia('(max-width: 749px)');

  function isMobile() {
    return MOBILE_MQ.matches;
  }

  function getHeaderOffset() {
    let offset = 12;
    const header = document.getElementById('shopify-section-header');
    const announcementNews = document.getElementById('shopify-section-announcement-news');
    const announcementBar = document.getElementById('shopify-section-announcement-bar');

    if (announcementNews) offset += announcementNews.offsetHeight;
    if (announcementBar) offset += announcementBar.offsetHeight;
    if (header) offset += header.offsetHeight;

    return offset;
  }

  function getTarget(hash) {
    if (!hash || hash === '#') return null;
    const id = decodeURIComponent(hash.slice(1));
    return document.getElementById(id);
  }

  function scrollToTarget(target, behavior) {
    if (!target) return;
    const top = target.getBoundingClientRect().top + window.pageYOffset - getHeaderOffset();
    window.scrollTo({ top: Math.max(0, top), behavior: behavior || 'smooth' });
  }

  function scrollToHash(hash, behavior) {
    scrollToTarget(getTarget(hash), behavior);
  }

  function whenLpImagesSettled(callback) {
    const images = document.querySelectorAll(
      '.lp-pdp-strip img, .lp-main__fv-img, .lp-main__slice-img'
    );
    const pending = [];

    images.forEach((img) => {
      if (!img.complete) pending.push(img);
    });

    if (!pending.length) {
      callback();
      return;
    }

    let remaining = pending.length;
    const done = () => {
      remaining -= 1;
      if (remaining <= 0) callback();
    };

    pending.forEach((img) => {
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
    });
  }

  function retryScrollToHash(hash) {
    scrollToHash(hash, 'auto');

    const delays = [100, 300, 600, 1000, 1800];
    delays.forEach((ms) => {
      window.setTimeout(() => scrollToHash(hash, ms >= 600 ? 'smooth' : 'auto'), ms);
    });

    whenLpImagesSettled(() => {
      scrollToHash(hash, 'smooth');
      window.setTimeout(() => scrollToHash(hash, 'smooth'), 200);
    });
  }

  document.addEventListener('click', (event) => {
    if (!isMobile()) return;

    const link = event.target.closest('a[href^="#"]');
    if (!link) return;

    const hash = link.getAttribute('href');
    const target = getTarget(hash);
    if (!target) return;

    event.preventDefault();
    retryScrollToHash(hash);
  });

  function handleInitialHash() {
    if (!isMobile() || !window.location.hash) return;
    window.setTimeout(() => retryScrollToHash(window.location.hash), 0);
  }

  if (document.readyState === 'complete') {
    handleInitialHash();
  } else {
    window.addEventListener('load', handleInitialHash, { once: true });
  }
})();
